import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

/**
 * CRUD-Service fuer {@code em.EmSchemaRuntimeData}.
 * <p>
 * Die Endpunkte folgen dem generischen {@code /mvsa/em/emSchemaRuntimeDatas}-
 * Schema. Metriken werden backend-seitig automatisch aus dem referenzierten
 * {@code DmDocument} hydriert (siehe {@code EmSchemaRuntimeDataListener}), das
 * Frontend muss daher beim Create nur die {@code documentDtoId} liefern.
 */
@Injectable({
    providedIn: 'root'
})
export class EmSchemaRuntimeDataService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/em/emSchemaRuntimeData');
    }

}
